import { Grid, Typography, Paper, Box, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Container } from "@mui/system";
import React from "react";
import globals from "../globals";
import MaterialsUploadPage from "./materialUpload";
import RedButton from "../components/redButton";
import { useAuth } from "../context/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import LoadingPage from "../error_page/loadingPage";


const MaterialsPage = () => {
    const { user, token } = useAuth();
    const { id, student_id } = useParams();
    const [showAddTheme, setShowAddTheme] = React.useState(false);
    const [materials, setMaterials] = React.useState([]);
    const [course, setCourse] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    const navigate = useNavigate();

    React.useEffect(() => {
        //console.log(id);
        fetch(`${globals.apiUrl}/courses/assignments/${id}/student/${student_id}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }
        ).then(response => response.json())
            .then(data => {
                if (data.detail) {
                    setLoading(false);
                    navigate('/something-went-wrong');
                }
                //console.log(data);
                // console.log(data.assignments[0].materials);
                setMaterials(data.assignments);
                setCourse(data.course);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
            });

    }, [id]);

    const handleClick = () => {
        setShowAddTheme((prev) => !prev); // toggle visibility
    };


    const addMaterial = (material) => {
        setMaterials([...materials, material]);
    }

    return (
        loading ? <LoadingPage /> : <Container>
            <Paper elevation={3} sx={{ p: 2 }}>
                <Grid container justifyContent={'space-evenly'} textAlign={'left'} alignItems={'center'}>
                    <Grid item xs={12} sm={9}>
                        <Typography >
                            <Box component='span' sx={{ color: globals.colors.lightRed, fontWeight: 'bold' }}>
                                Редактор на:
                            </Box>{" "}
                            <Box component="span" sx={{ color: globals.colors.textColor, fontWeight: 'bold' }}>
                                {user.first_name} {user.last_name}
                            </Box>
                        </Typography>
                        <Typography sx={{ mt: 2 }}>
                            <Box component='span' sx={{ color: globals.colors.lightRed, fontWeight: 'bold' }}>
                                Курс:
                            </Box>{" "}
                            <Box component="span" sx={{ color: globals.colors.textColor, fontWeight: 'bold' }}>
                                {course.title}
                            </Box>
                        </Typography>
                        <Typography sx={{ mt: 2 }}>
                            <Box component='span' sx={{ color: globals.colors.lightRed, fontWeight: 'bold' }}>
                                Ученик:
                            </Box>{" "}
                            <Box component="span" sx={{ color: globals.colors.textColor, fontWeight: 'bold' }}>
                                {course.student_name}
                            </Box>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <img src={course.image_url} width={250} height={150} />
                    </Grid>
                </Grid>
            </Paper>

            <Paper elevation={4} sx={{ p: 4, mt: 4, mb: 2 }}>
                <Grid container>
                    <Grid item xs={12} sm={12}>
                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 20 }}>Учебно съдържание - теми и материали </Typography>
                        <Typography sx={{ color: globals.colors.textColor, fontWeight: 'bold', mt: 1, mb: 3 }}>Съществуващи теми:</Typography>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        {materials?.map((material, i) => (
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Typography sx={{ fontSize: 17, color: globals.colors.darkBlue, fontWeight: 'bold' }}>{material.title}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <MaterialsUploadPage assignmentId={material.id} student_id={student_id} courseId={id} title={material.title} description={material.description} uploadId={`file-upload-${i}`} materials={material.materials} />
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Grid>
                    <Grid item>
                        <RedButton text='Добави тема' pX={3} mTop={3} onClick={handleClick} sx={{ mb: 2 }} />
                        {showAddTheme && <MaterialsUploadPage student_id={student_id} courseId={id} addMaterial={addMaterial} />}
                    </Grid>
                </Grid>
            </Paper>

            <Paper elevation={4} sx={{ p: 4, mt: 4, mb: 2 }}>
                <Grid container>
                    <Grid item xs={12} sm={12}>
                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 20 }}>Домашна работа на ученик по тема</Typography>
                    </Grid>

                    <Grid container sx={{ mt: 2 }} spacing={2}>
                        {materials?.filter(material => material.submission.length > 0).map(material => (
                            <Grid item sm={12} xs={12}>
                                <Paper elevation={4} sx={{ p: 3 }}>
                                    <a href={material.submission[0].files_urls[0]} ><Typography sx={{ fontWeight: 'bold' }}>{material.submission[0].files_urls[0].split('/').pop()}</Typography></a>
                                    <Typography>{course.student_name} - {material.title} - {new Date(material.created_at).toLocaleString(
                                        "bg-BG",
                                        {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                        }
                                    )}</Typography>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Paper>

        </Container >
    );
}

export default MaterialsPage;